<template lang="pug">
section
  .hero
    .hero-body
      .container
        .columns.is-centered.is-vcentered
          .column.is-narrow
            h1.title Podcast
            h2.subtitle Listen now
            figure.image.is-96x96
              img.grow(src="@/assets/podcasts.png", @click="openPodcast")
            br
            b-button(type="is-link", tag="a", href="https://twitter.com/Per36Pod", target="_blank")
              font-awesome-icon(:icon="['fab', 'twitter']")
              span  Follow
              
          .column.is-one-fifth
            figure.image
              img(src="@/assets/per36.png")
</template>

<script>
export default {
  name: "Podcasts",

  methods: {
    openPodcast() {
      window.open(
        "https://podcasts.apple.com/us/podcast/per-36/id1485406219",
        "_blank"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.grow {
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.grow:hover {
  transform: scale(1.05);
}
</style>
